<template>
  <div class="container">
    <div v-if="isMember">
      <div v-if="projectId && !projectLoading" class="">
        <div class="row mb-3">
          <h5 class="mb-0 col-md-6"><i class="fa fa-bell"></i> Project Notification Settings</h5>
        </div>
        <div class="row mb-3">
          <h6 class="mb-2 col-md-12">
            CitSci allows you to receive notifications when various activities occur for a project.
            Choose how you would like to be notified for the activities below in this project.
          </h6>
          <!--          <div class="row ml-4" style="border: 1px solid;">-->
          <!--            <span class="ml-2 mr-2 mt-2 mb-2">-->
          <!--            <font-awesome-icon class="ml-2 mr-2" icon="fa-solid fa-info"/>-->
          <!--            Project level notification settings override-->
          <!--              <a href="#" @click="$bvModal.show('account-notification-settings')">Account level Notification Settings</a>-->
          <!--            </span>-->
          <!--          </div>-->
        </div>

        <div class="row justify-content-between mr-2 ml-2">
          <b-table
            striped
            bordered
            :items="prefs"
            :fields="tableFields">
            <template v-slot:head(emailNotify)>
              <i class="fa fa-envelope mr-1"></i> Email
            </template>
            <template v-slot:cell(emailNotify)="row">
              <b-form-checkbox
                v-model="row.item.emailNotify"
                :value=true
                :unchecked-value=false
                @change="update(row.item)"
                switch
                size="lg">
              </b-form-checkbox>
            </template>

            <template v-slot:head(webNotify)>
              <i class="fa fa-bell mr-1"></i> Web
            </template>
            <template v-slot:cell(webNotify)="row">
              <b-form-checkbox
                v-model="row.item.webNotify"
                :value=true
                :unchecked-value=false
                @change="update(row.item)"
                switch
                size="lg">
              </b-form-checkbox>
            </template>
            <template v-slot:cell(updatedAt)="row">
              <DateTime v-if="row.item.updatedAt" :date="row.item.updatedAt" :dateTime="false"></DateTime>
            </template>
          </b-table>
        </div>

        <!--        <b-modal id="account-notification-settings"-->
        <!--                 ref="accountNotificationSettings"-->
        <!--                 size="lg"-->
        <!--                 button-size="sm"-->
        <!--                 no-stacking-->
        <!--                 centered-->
        <!--                 hide-footer>-->
        <!--          <div class="card-body">-->
        <!--            <NotificationSettings></NotificationSettings>-->
        <!--          </div>-->
        <!--        </b-modal>-->
      </div>
    </div>
    <RequiresMember v-else page="Notifications"></RequiresMember>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import VueLoader from "../../../layout/Loader";
import RequiresMember from "../tabpermission/requiresMember.vue";
import DateTime from "../../../../components/common/date-time/DateTime.vue";
import {NOTIFICATION_TYPES} from "../../../../constants/notification_types"
// import NotificationSettings from "../../../user/profile/preferences/NotificationSettings.vue";


export default {
  name: "ProjectMemberNotificationTable",
  components: {
    RequiresMember,
    VueLoader,
    DateTime,
    // NotificationSettings,
  },
  data() {
    return {
      prefs: null,
      notificationTemplate: {
        notificationType: '',
        user: '',
        projectMember: '',
        emailNotify: false,
        webNotify: false,
        updatedAt: null
      },

      tableFields: [
        {
          key: "type",
          label: "Notification Type",
          sortable: false,
          sortDirection: "asc",
          tdClass: "text-left",
        },
        {
          key: "emailNotify",
          label: 'Email',
          sortable: false,
          class: "text-center"
        },
        {
          key: "webNotify",
          label: 'Web',
          class: "text-center"
        },
        {
          key: "updatedAt",
          label: "Date Updated",
          sortDirection: "asc",
          tdClass: "text-center",
          class: "text-center"
        },
      ]
    };
  },
  created() {
    if (this.memberIRI) {
      this.getProjectMemberPrefs({memberId: this.memberIRI})
    }
  },
  watch: {
    memberIRI(newVal) {
      if (newVal) {
        this.getProjectMemberPrefs({memberId: newVal})
      }
    },
    memberPreferences(newVal, oldVal) {
      if (newVal) {
        if (newVal.length < 5) {
          // Add missing preferences
          for (const [key, value] of Object.entries(NOTIFICATION_TYPES)) {
            if (!newVal.find(val => val.notificationType === key)) {
              // Add notification type
              let newPref = {...this.notificationTemplate}
              newPref.projectMember = this.memberIRI
              newPref.user = this.userIRI
              newPref.notificationType = key
              newVal.push(newPref)
            }
          }
        }
        this.prefs = newVal.map(pref => ({type: NOTIFICATION_TYPES[pref['notificationType']], ...pref}))
      }
    },
  },
  computed: {
    ...mapGetters({
      projectId: "project/get/id",
      projectLoading: "project/get/isLoading",
      isMember: "project/get/isMember",
      memberIRI: "project/get/memberIRI",
      userIRI: "user/profile/iri",
      prefsLoading: "user/notification_preference/isLoading",
      memberPreferences: "user/notification_preference/memberPreferences",
      prefsError: "user/notification_preference/error",
    }),
  },
  methods: {
    ...mapActions({
      getProjectMemberPrefs: "user/notification_preference/getProjectMemberPrefs",
      addUpdateMemberPref: "user/notification_preference/addUpdateMemberPref",
    }),
    update(pref) {
      this.addUpdateMemberPref(pref)
    }
  }
};
</script>

<style scoped lang="scss">
</style>
